import { useState } from 'react'
import { Collapse, Group, IconButton, iconSizes, Paper, Stack, Title } from '@common/ui'
import { IconChevronDown } from '@common/ui/icons'

type CollapsableProps = {
  title: string
  children: React.ReactNode
}

const Collapsable = ({ title, children }: CollapsableProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Paper shadow="xs" p="md" radius="xs" bg="var(--trellis-color-surface-variant)">
      <Stack gap={0}>
        <Group gap="md" wrap="nowrap">
          <IconButton
            size="sm"
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
            aria-label="toggle page expansion"
            style={{
              transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              transition: 'transform 200ms',
            }}
          >
            <IconChevronDown size={iconSizes.sm} stroke={1.5} />
          </IconButton>
          <Title order={4}>{title}</Title>
        </Group>
        <Collapse expanded={expanded}>{children}</Collapse>
      </Stack>
    </Paper>
  )
}

export default Collapsable
